<div class="flex-box">
    <filter-panel *ngIf="activeMenuCodes.includes(MapMenuCode.FILTERS)" class="flex-box"></filter-panel>
</div>
<div class="app-menus">
    <layer-list *ngIf="activeMenuCodes.includes(MapMenuCode.LAYERS)" class="map-menus layer-list"></layer-list>
    <task-panel class="task-list map-menus" *ngIf="activeMenuCodes.includes(MapMenuCode.TASKS)"></task-panel>
</div>
